module.exports = __webpack_public_path__ + "img/lot_john_r_cars.e4087ae5.jpg";